var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11,0c5.9-0.1,10.9,4.8,11,11c0.1,6.1-4.9,11-11,11S0,17.1,0,11S4.9,0.1,11,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F95111",
    d: "M11,7.3c0.7,0,1.2-0.6,1.2-1.2S11.7,4.8,11,4.8S9.7,5.3,9.7,6S10.3,7.3,11,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F95111",
    d: "M14.3,15.8h-2.1l0-6.2c0-0.5-0.4-0.8-0.9-0.8l-1.7,0c-0.1,0-0.1,0-0.2,0C9.2,8.8,9,8.9,8.9,9.1 C8.8,9.2,8.7,9.5,8.7,9.7c0.1,0.4,0.5,0.8,0.9,0.7h0.9v5.4H8.7c-0.5,0-0.9,0.3-0.9,0.8s0.4,0.8,0.9,0.8h5.7 c0.5,0,0.9-0.3,0.9-0.8S14.8,15.8,14.3,15.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d5b0da2e.svg";
export { ForwardRef as ReactComponent };